var _rect, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFacility(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    rx: 4,
    fill: "#E6F0F7"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 4.22461H20C20.6732 4.22461 21.2442 4.46202 21.7246 4.94238C22.2049 5.42271 22.4414 5.99388 22.4414 6.66699V14.8916H25.333C26.0062 14.8916 26.5773 15.129 27.0576 15.6094C27.5378 16.0896 27.7753 16.66 27.7754 17.333V25.333C27.7754 26.0062 27.538 26.5773 27.0576 27.0576C26.5773 27.538 26.0062 27.7754 25.333 27.7754H17.5586V22.4414H14.4414V27.7754H6.66699C5.99381 27.7754 5.42275 27.538 4.94238 27.0576C4.46202 26.5773 4.22461 26.0062 4.22461 25.333V12C4.22461 11.3268 4.46202 10.7558 4.94238 10.2754C5.42271 9.79514 5.99388 9.55859 6.66699 9.55859H9.55859V6.66699C9.55859 5.99388 9.79514 5.42271 10.2754 4.94238C10.7558 4.46202 11.3268 4.22461 12 4.22461ZM6.44141 25.5586H9.55859V22.4414H6.44141V25.5586ZM22.4414 25.5586H25.5586V22.4414H22.4414V25.5586ZM6.44141 20.2246H9.55859V17.1084H6.44141V20.2246ZM11.7754 20.2246H14.8916V17.1084H11.7754V20.2246ZM17.1084 20.2246H20.2246V17.1084H17.1084V20.2246ZM22.4414 20.2246H25.5586V17.1084H22.4414V20.2246ZM6.44141 14.8916H9.55859V11.7754H6.44141V14.8916ZM11.7754 14.8916H14.8916V11.7754H11.7754V14.8916ZM17.1084 14.8916H20.2246V11.7754H17.1084V14.8916ZM11.7754 9.55859H14.8916V6.44141H11.7754V9.55859ZM17.1084 9.55859H20.2246V6.44141H17.1084V9.55859Z",
    fill: "#036BAD",
    stroke: "white",
    strokeWidth: 0.45
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacility);
export default __webpack_public_path__ + "static/media/facility.4e89fcb9bfacbbb3e3c77a4662aca454.svg";
export { ForwardRef as ReactComponent };